export const SVG_Y_SCALE = 0.1
export const SVG_OFFSET = 0.1
export const SMALL_DX = 0.000000001
export const OFFSET_DX = 1/1000
export const TEXT_OFFSET = 0.1
